import { forwardRef } from 'react';

import { IconProps } from './icon';

export const WarningTriangleIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        fill="currentColor"
        d="M11 13.5263C11 14.0786 10.5523 14.5263 10 14.5263C9.44772 14.5263 9 14.0786 9 13.5263C9 12.974 9.44772 12.5263 10 12.5263C10.5523 12.5263 11 12.974 11 13.5263Z"
      />
      <path
        fill="currentColor"
        d="M10 7.52631C9.58579 7.52631 9.25 7.86209 9.25 8.27631V10.7763C9.25 11.1905 9.58579 11.5263 10 11.5263C10.4142 11.5263 10.75 11.1905 10.75 10.7763V8.27631C10.75 7.86209 10.4142 7.52631 10 7.52631Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.732 5.02631C10.9622 3.69297 9.03767 3.69297 8.26787 5.02631L3.07171 14.0263C2.30191 15.3596 3.26417 17.0263 4.80377 17.0263H15.1961C16.7357 17.0263 17.6979 15.3596 16.9281 14.0263L11.732 5.02631ZM15.6291 14.7763L10.4329 5.77631C10.2405 5.44297 9.75936 5.44297 9.5669 5.77631L4.37075 14.7763C4.1783 15.1096 4.41886 15.5263 4.80377 15.5263H15.1961C15.581 15.5263 15.8215 15.1096 15.6291 14.7763Z"
      />
    </svg>
  );
});

export default WarningTriangleIcon;
